import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '~app/shared/shared.module';
import { SubscriptionPeriodSelectionComponent } from './subscription-period-selection.component';


@NgModule({
  declarations: [SubscriptionPeriodSelectionComponent],
    imports: [
      CommonModule,
      MatButtonModule,
      RouterModule,
      MatCardModule,
      TranslateModule,
      SharedModule,
    ]
})
export class SubscriptionPeriodSelectionModule { }